import React, { useEffect, useState } from 'react'
import GeneratedProposal from './GeneratedProposal'
import { useParams } from 'react-router-dom';

export default function PreviewQuote() {
    const { id } = useParams<any>();
    const [transactionId, setTransactionId] = useState<any>("");

    useEffect(() => {
        document.title="Quote for you"
        setTransactionId(id);
    }, []);

    return (
        <div>
            <GeneratedProposal
                transactionId={transactionId}
                isEditable={false}
            />
        </div>
    )
}
